import YFormRange from './Range';

export { YFormRange };
export default YFormRange;
